import { compose } from 'recompose';

import PostEdit from './PostEdit';

const enhance = compose();

export default enhance(PostEdit);
